import React from 'react';
import { FaCheck, FaTruck } from 'react-icons/fa';

function ContactForm({
  book,
  format,
  firstName, onFirstNameChange,
  lastName, onLastNameChange,
  email, onEmailChange,
  phone, onPhoneChange,
  digitalType, onDigitalTypeChange,
  couponCode, couponStatus, couponDiscount, onCouponChange,
  wilaya, onWilayaChange, wilayaOptions,
  commune, onCommuneChange, communeOptions,
  deliveryMethod, onDeliveryMethodChange,
  deliveryFee,
  errors,
}) {
  const isCouponValid = couponStatus === 'valid';
  const hasCouponError =
    couponStatus === 'invalid' ||
    couponStatus === 'digital_only' ||
    couponStatus === 'network_error';

  return (
    <div className="form-grid">
      <input
        placeholder="First name *"
        value={firstName}
        onChange={onFirstNameChange}
        className={errors.firstName ? 'input-error' : ''}
        aria-label="First name"
      />

      <input
        placeholder="Last name *"
        value={lastName}
        onChange={onLastNameChange}
        className={errors.lastName ? 'input-error' : ''}
        aria-label="Last name"
      />

      {format === 'digital' && (
        <>
          <input
            placeholder="Email address *"
            value={email}
            onChange={onEmailChange}
            className={errors.email ? 'input-error' : ''}
            aria-label="Email address"
          />

          <select
            value={digitalType}
            onChange={onDigitalTypeChange}
            aria-label="Digital format"
          >
            <option value="pdf">PDF</option>
            <option value="epub">ePub</option>
          </select>

          {!book.isBundle && (
            <div className="coupon-row">
              <div className="coupon-input-wrap">
                <input
                  type="text"
                  placeholder="Coupon code (optional)"
                  value={couponCode}
                  onChange={onCouponChange}
                  className={hasCouponError ? 'input-error' : ''}
                  aria-label="Coupon code"
                  aria-describedby={
                    hasCouponError ? 'coupon-message' : undefined
                  }
                />
              </div>

              {isCouponValid && (
                <div
                  className="coupon-success-field"
                  aria-live="polite"
                  aria-label={`${Math.round(
                    couponDiscount * 100
                  )}% discount applied`}
                >
                  <FaCheck className="coupon-success-icon" />
                  <span>
                    {Math.round(couponDiscount * 100)}% discount applied
                  </span>
                </div>
              )}

              {hasCouponError && (
                <div
                  id="coupon-message"
                  className="coupon-msg coupon-error-message"
                  aria-live="polite"
                >
                  {couponStatus === 'invalid' &&
                    "This code doesn't exist or has expired."}

                  {couponStatus === 'digital_only' &&
                    'This coupon is only valid for e-book orders.'}

                  {couponStatus === 'network_error' &&
                    "Couldn't verify coupon — check your connection."}
                </div>
              )}
            </div>
          )}
        </>
      )}

      {format === 'paper' && (
        <>
          <input
            placeholder="Phone number *"
            value={phone}
            onChange={onPhoneChange}
            className={errors.phone ? 'input-error' : ''}
            aria-label="Phone number"
          />

          {errors.phone && phone.trim().length > 0 && phone.trim().length < 9 && (
            <p className="field-error-msg">
              Please enter a valid phone number.
            </p>
          )}

          <input
            placeholder="Email address *"
            value={email}
            onChange={onEmailChange}
            className={errors.email ? 'input-error' : ''}
            aria-label="Email address"
          />

          {errors.email && email.trim().length > 0 && (
            <p className="field-error-msg">
              Please enter a valid email address.
            </p>
          )}

          <select
            value={wilaya}
            onChange={onWilayaChange}
            className={errors.wilaya ? 'input-error' : ''}
            aria-label="Wilaya"
          >
            <option value="">Select Wilaya *</option>

            {wilayaOptions.map((w) => (
              <option key={w} value={w}>
                {w}
              </option>
            ))}
          </select>

          <select
            value={commune}
            onChange={onCommuneChange}
            disabled={!wilaya}
            className={errors.commune ? 'input-error' : ''}
            aria-label="Commune"
          >
            <option value="">Select Commune *</option>

            {communeOptions.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>

          <select
            value={deliveryMethod}
            onChange={onDeliveryMethodChange}
            aria-label="Delivery method"
          >
            <option value="home">Home delivery</option>
            <option value="office">Office pickup</option>
          </select>

          {deliveryFee && (
            <div className="delivery-fee-note">
              <FaTruck className="delivery-fee-icon" />

              <span>
                Estimated{' '}
                {deliveryMethod === 'home'
                  ? 'home delivery'
                  : 'office pickup'}{' '}
                fee for <strong>{wilaya}</strong>:{' '}
                <strong>{deliveryFee} DA</strong> — paid directly at the
                agency when you receive your copy.
              </span>
            </div>
          )}

          {wilaya && !deliveryFee && (
            <div className="delivery-fee-note delivery-fee-unknown">
              <FaTruck className="delivery-fee-icon" />

              <span>
                Delivery fee will be paid at the agency upon receiving your
                copy. Exact amount to be confirmed.
              </span>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default ContactForm;